import { Box } from '@mui/material'
import { SystemBanner } from './SystemBanner'
import { type SystemBannerDTO } from 'src/types/api'
import { orderBy } from 'lodash'
import { useEffect, useState } from 'react'

interface SystemBannerDisplayProps {
  systemBanners: SystemBannerDTO[]
}

export const SystemBannerDisplay = ({
  systemBanners,
}: SystemBannerDisplayProps) => {
  const [visibleBanners, setVisibleBanners] = useState<SystemBannerDTO[]>([])

  useEffect(() => {
    setVisibleBanners(
      orderBy(systemBanners, ['type', 'startDate'], ['desc', 'desc'])
    )
  }, [systemBanners])

  const handleFilterBanners = (id: number) => {
    const filteredBanners = visibleBanners.filter((banner) => banner.id !== id)
    setVisibleBanners(filteredBanners)
  }

  return (
    <Box className="flex flex-col gap-2">
      {visibleBanners.map((banner) => (
        <SystemBanner
          key={banner.id}
          message={banner.content}
          dismissable={banner.dismissable}
          type={banner.type}
          filterBanners={() =>
            banner.id != null && handleFilterBanners(banner.id)
          }
        />
      ))}
    </Box>
  )
}
